import React, { useEffect, useState } from 'react';
import {
    Container,
    Typography,
    CssBaseline,
    Box,
    CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import VerificationForm from './VerificationForm';
import { setPassword } from '../Queries';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(to right, #0a0068, #cc4049)',
    },
    formContainer: {
        background: '#fff',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px',
    },
    errorMessage: {
        color: 'red',
        textAlign: 'center',
        marginTop: '10px'
    }
});

const ConfirmSignupPage = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const storedEmail = localStorage.getItem('confirmEmail');
        if (storedEmail) setEmail(storedEmail);
    }, []);

    const handleConfirm = async (code, emailParam, password) => {
        setErrorMessage('');
        setLoading(true);
        try {
            await Auth.confirmSignUp(emailParam, code);
            await setPassword(emailParam, password); // Backend should call AdminSetUserPassword
            setSuccess(true);
            localStorage.removeItem('confirmEmail');
        } catch (error) {
            setErrorMessage(error.message || 'Confirmation failed');
        } finally {
            setLoading(false);
        }
    };

    const handleResendCode = async (emailParam) => {
        setErrorMessage('');
        try {
            await Auth.resendSignUp(emailParam);
            alert('Verification code resent to your email.');
        } catch (error) {
            setErrorMessage(error.message || 'Failed to resend code');
        }
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Container className={classes.formContainer}>
                <Typography component="h1" variant="h5" align="center">
                    Confirm Email & Set Password
                </Typography>

                {loading && !success && (
                    <Box display="flex" justifyContent="center" mt={3}>
                        <CircularProgress />
                    </Box>
                )}

                <VerificationForm
                    email={email}
                    onConfirm={handleConfirm}
                    onResend={handleResendCode}
                    errorMessage={errorMessage}
                    showEmailField={!email}
                    success={success}
                    loading={loading}
                    requirePassword={true}
                />
            </Container>
        </div>
    );
};

export default ConfirmSignupPage;
